import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {Link} from 'gatsby';

function Harness(props) {
    return (
        <section className="tekrevol_light_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="GCP Benefits">
                            <h2>Google Cloud Consulting Services To Redefine Your Digital Future</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>Google Cloud Consulting services by TekRevol enable businesses to step up their cloud game and redefine their digital footprints. From Google Cloud data architecture to workload inventory to design architecture – TekRevol takes care of everything for you!</p>

                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Harness;